module.exports = __webpack_public_path__ + "static/media/cityscape_resized.7218e04c.png";